import * as React from "react";
const NewsLeftBold2 = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 16 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 26L2 14L14 2"
      stroke="white"
      strokeWidth={props.font}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 26L2 14L14 2"
      stroke="white"
      strokeWidth={props.font}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default NewsLeftBold2;
